import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'

import * as customizationSelectors from 'customizer/customization/selectors'
import useThemeSettings from 'customizer/theme/useThemeSettings'

import './Title.scss'

const { customizerTitleSelector } = customizationSelectors

const Title = ({ isMobile }: { isMobile?: boolean }) => {
  const title = useSelector(customizerTitleSelector)
  const customizerTitle = useThemeSettings('customizerTitle')

  const titleClassNames = classNames('title', {
    'title--mobile': isMobile,
  })

  return (
    <div
      className={titleClassNames}
      style={
        isMobile
          ? {
              color: customizerTitle.mobileColor,
              fontFamily: customizerTitle.fontFamily?.fontFamily,
              fontSize: customizerTitle.mobileFontSize,
            }
          : {
              backgroundColor: customizerTitle.backgroundColor,
              fontFamily: customizerTitle.fontFamily?.fontFamily,
              fontSize: customizerTitle.fontSize,
              color: customizerTitle.color,
              borderBottomColor: customizerTitle.dividerColor,
              borderBottomWidth: customizerTitle.dividerWidth,
            }
      }
    >
      {title}
    </div>
  )
}

export default Title
